import { gql } from '@apollo/client';

export const GET_FRAUD_CASE_IDS = gql`
  query GetFraudCaseIds {
    fraudCases {
      id
    }
  }
`;

export const GET_FRAUD_CASES = gql`
  query GetFraudCases {
    fraudCases {
      id
      scannedAtA
      scannedAtB
      createdAt
      status
      resolutionReason
      resolvedAt
      userA { id firstName lastName email }
      userB { id firstName lastName email }
      pharmacyA { id namePharmacy address }
      pharmacyB { id namePharmacy address }
      product { id name }
      promotion { id name }
      label { id code }
    }
  }
`;

export const RESOLVE_FRAUD_CASE = gql`
  mutation ResolveFraudCase($id: ID!, $reason: String!) {
    resolveFraudCase(id: $id, reason: $reason) {
      id
      status
      resolutionReason
      resolvedAt
    }
  }
`;
